import { useEffect, useState } from 'react';
import { Card, Col, Image, Row, Typography } from 'antd';

import classes from './index.module.less';

const PromoContainer = (props: any) => {
	const data = props.promo;
	const slicedData = data.slice(0, 3);
	const [imageBroken, setImageBroken] = useState('');
	useEffect(() => {}, [imageBroken]);
	return (
		<div className={classes['page-body-wrap']}>
			<div className="container">
				<div className={classes.pagehero}>
					<div className={classes.headContact}>
						<h2 className={classes.title}>Promo Menarik Buat Mama</h2>
						<Typography className={classes.paragraph}>Biar Mama makin seneng!</Typography>

						{slicedData.length === 0 ? (
							<div style={{ textAlign: 'center', padding: '20px' }}>
								<Image
									alt="empty-promp"
									src="/icons/emptyEvent.svg"
									className={classes.imageContainer}
									preview={false}
								/>
							</div>
						) : (
							<Row>
								{slicedData.map((item: any) => (
									<Col md={8} sm={8} xs={24} lg={8} xl={8} key={item.title}>
										<br />
										<a
											href={item.url_path}
											target="_blank"
											rel="noopener noreferrer"
											id="komunitas-promo"
										>
											<Card
												cover={
													<Image
														alt={item.title}
														src={
															item.image_files[0].path === imageBroken
																? 'images/default/no-image.svg'
																: item.image_files[0].path
														}
														style={{
															borderRadius: '8px',
															// width: '95%',
															// height: '150px',
															objectFit: 'cover',
														}}
														preview={false}
														onError={() => {
															setImageBroken(item.image_files[0].path);
														}}
													/>
												}
												style={{
													border: 'none',
													marginLeft: '15px',
												}}
											/>
										</a>
									</Col>
								))}
							</Row>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default PromoContainer;
